import React, { useState, useContext, useEffect } from "react";
import {Link} from 'react-router-dom';
import { css } from "emotion";
import { darken } from "polished";
import { boxStyles, colors } from "../../styles/theme";
import workspaces from "../../services/api/workspaces";
import ProgressBar from "./ProgressBar";
import {GlobalContext} from "../../context/GlobalState";
import getPlan from "../../utils/getPlan";

const Usage = () => {
  const {currentWorkspace} = useContext(GlobalContext);
  const [currentViews, setCurrentViews] = useState(0);
  const [maxViews, setMaxViews] = useState(2000);
  const [percentage, setPercentage] = useState(0);
  const plan = getPlan(currentWorkspace);

  useEffect(() => {
    setMaxViews(plan.maxViews);
    updateViews();
  }, []);

  const updateViews = async () => {
    const {data: usage} = await workspaces.getUsage(currentWorkspace.id);

    setCurrentViews(usage.currentViews);
    setMaxViews(usage.maxViews);
    setPercentage(usage.percentage);
  };

  return (
    <div className={container}>
      <div className="progressbar-description">
        <div className="description-line">
          <div className="subscription-name">{plan.name[0].toUpperCase() + plan.name.slice(1)} <span className="desktop">Subscription</span></div>
          <Link to={`/plans`} className="upgrade">Update subscription</Link>
        </div>
        <div className="description-line end">
          <div className="view-usage"><span>{`${(currentViews || 0).toLocaleString('en-US')} of ${(maxViews || 0).toLocaleString('en-US')}`} ({Math.round(percentage * 10) / 10}%)</span> <span className="desktop">views used</span></div>
        </div>
      </div>
      <ProgressBar percentage={percentage > .5 ? percentage : percentage > 0 ? .5 : 0}/>
    </div>
  );
};

export default Usage;

const container = css`
  margin-bottom: 30px;
  padding: ${boxStyles.standardPadding};

  .subscription-name {
    font-size: 18px;
    color: #191919;
    letter-spacing: 1px;
    font-weight: bold;
  }
  
  .progressbar-description {
    margin-bottom: 10px;
  }
  
  .description-line {
    display: flex;
    justify-content: space-between;
    
    &.end {
      justify-content: flex-end;
    }
    
    .upgrade {
      color: ${colors.brandColor};
      text-decoration: none;
      transition-duration: .2s;
      
      &:hover {
        color: ${darken(.1, colors.brandColor)};
      }
    }
    
    .view-usage {
      color: ${colors.placeholderText};
      
      span:nth-child(1) {
        font-weight: 500;
      }
    }
    
    .desktop {
      display: none;
    }
  }
  
  
  
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: 12px 0;
   
   
   .description-line {
    .desktop {
      display: inline-block;
    }
   }
  }
`;
